import { render, staticRenderFns } from "./PendingTrusteeSales.vue?vue&type=template&id=a65ebe5c&"
import script from "./PendingTrusteeSales.vue?vue&type=script&lang=js&"
export * from "./PendingTrusteeSales.vue?vue&type=script&lang=js&"
import style0 from "./PendingTrusteeSales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports